import * as React from 'react';
import Modal from 'antd/lib/modal';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { Button, Select, message } from 'src/Library/AntdLibComponents';
import withStyles from 'react-jss';
import { validateEmail } from 'src/utils/utils';
import { notifyBookingUsers } from 'src/api/booking';
import { tokens } from 'src/design-system';

const styles = () => ({
  modal: {
    '& .ant-modal-body': {
      padding: '16px 16px 32px 14px',
    },
    '& .ant-modal-header': {
      borderBottom: '1px solid #DDE0E5',
      padding: '16px',
    },
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  isVisible: boolean;
  handleCancel: () => void;
  bookingId: string;
  handleSuccess: () => void;
}

interface StateProps {
  isBooking?: boolean;
  notifyUserEmails?: string[];
  emailError?: boolean;
}

const AdditionalEmailsForBookingModal = (props : IProps) => {
  const {
    isVisible,
    handleCancel,
    bookingId,
    classes,
    handleSuccess,
  } = props;

  const [state, setState] = useGenericState<StateProps>({});

  const {
    isBooking,
    notifyUserEmails,
  } = state;

  const handleSubmit = async () => {
    if (notifyUserEmails?.some((email => !validateEmail(email)))) {
      message.error('Please enter valid email address');
      return;
    }
    setState({ isBooking: true });
    const response = await notifyBookingUsers({
      bookingId,
      notifyUserEmails,
    });

    if (response.isSuccess) {
      handleSuccess();
    } else {
      message.error(response.errorMessage);
    }
    setState({ isBooking: false });
  }

  const renderFooter = () => {
    return (
      <div>
        <Button
          style={{
            backgroundColor: '#F2F4F6',
            border: '1px solid #DDE0E5',
            color: '#424242',
            fontSize: `${tokens.fontSize.small}px`,
          }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          loading={isBooking}
          disabled={!notifyUserEmails?.length}
          style={{
            backgroundColor: tokens.colors.primary,
            border: tokens.colors.primary,
            color: tokens.colors.bgWhite,
            marginLeft: '16px',
            fontSize: `${tokens.fontSize.small}px`,
          }}
          onClick={handleSubmit}
        >
          Send
        </Button>
      </div>
    );
  }

  return (
    <Modal
      width={348}
      title="Notify Users"
      visible={isVisible}
      onCancel={handleCancel}
      footer={renderFooter()}
      className={classes.modal}
    >
      <div style={{ marginBottom: '8px', color: '#262626', fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}>
        Email
      </div>
      <Select
        mode="tags"
        placeholder="Email"
        tokenSeparators={[',']}
        style={{ width: '100%' }}
        value={notifyUserEmails}
        onChange={(notifyUserEmails) => setState({ notifyUserEmails })}
        notFoundContent={null}
      />
    </Modal>
  );
};

export default withStyles(styles)(React.memo(AdditionalEmailsForBookingModal));
